import {
  ShowBreedComparisonScreen,
  ShowBreedComparisonScreenProps,
} from 'shared/screens/breeds/show-breed-comparison';
import { withServerProps } from '@web/library/with-server-props';
import { Page } from '@web/components/page';
import { useTranslation } from 'react-i18next';

export default function CompareBreeds(props: ShowBreedComparisonScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) =>
        seo
          .setTitle(
            t('breeds.compare_breeds.title', {
              breed1: props.breed.name,
              breed2: props.comparable.name,
            }),
            false,
          )
          .setDescription(
            t('breeds.compare_breeds.description', {
              breed1: props.breed.name,
              breed2: props.comparable.name,
            }),
          )
          .setImage(props.breed.avatar?.url)
      }
    >
      <ShowBreedComparisonScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(ShowBreedComparisonScreen.pageBuilder);
